import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { Icon, IconModule } from '@y42/core/icon';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';

type SortKey = null | 'asc' | 'desc';

export interface IconHeaderRendererComponentParams {
  icon: Icon;
  displayName: string;
}

interface IconHeaderRendererParams extends IHeaderParams, IconHeaderRendererComponentParams {}

@UntilDestroy()
@Component({
  imports: [IconModule, CommonModule],
  standalone: true,
  selector: 'y42-icon-header-renderer',
  templateUrl: './icon-header-renderer.component.html',
  styleUrls: ['./icon-header-renderer.component.scss'],
})
export class IconHeaderRendererComponent implements IHeaderAngularComp, OnDestroy {
  params!: IconHeaderRendererParams;

  @ViewChild('menuButton', { read: ElementRef }) public menuButton?: ElementRef;

  private readonly filterActive$$ = new BehaviorSubject<boolean>(false);

  sorted: SortKey = null;

  public readonly state = connectState(this, {
    filterActive: this.filterActive$$,
  });

  agInit(params: IconHeaderRendererParams): void {
    this.params = params;
    this.params.column.addEventListener('sortChanged', this.sortChange);
    this.params.column.addEventListener('filterChanged', this.changeFilter);
    this.filterActive$$.next(this.params.column.isFilterActive());
  }

  ngOnDestroy(): void {
    this.params.column.removeEventListener('sortChanged', this.sortChange);
    this.params.column.addEventListener('filterChanged', this.changeFilter);
  }

  refresh(params: IconHeaderRendererParams): boolean {
    this.params = params;
    return true;
  }

  readonly sortChange = () => {
    this.sorted = null;
    if (this.params.column.isSortAscending()) {
      this.sorted = 'asc';
    } else if (this.params.column.isSortDescending()) {
      this.sorted = 'desc';
    }
  };

  showSorted() {
    this.params.setSort(this.sortSwitch(this.sorted));
  }

  sortSwitch(sort: SortKey) {
    if (sort === null) {
      return 'asc';
    } else if (sort === 'asc') {
      return 'desc';
    } else {
      return null;
    }
  }

  showColumnMenu() {
    if (this.menuButton) {
      this.params.showColumnMenu(this.menuButton.nativeElement);
    }
  }

  readonly changeFilter = () => {
    this.filterActive$$.next(this.params.column.isFilterActive());
  };
}
